import tenantUtils from '@utils';
import cx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { Icon } from '../../../../components/common';
import { getBaseURL, TENANT_KEY } from '../../../../utility/env';

// Same sites, order and flag assets as the bayut.sa footer country menu.
const COUNTRY_SITES = [
  {
    title: 'United Arab Emirates',
    title_l1: 'الإمارات العربية المتحدة',
    href: 'https://www.bayut.com',
    flag: 'iconUAE',
  },
  { title: 'Jordan', title_l1: 'الأردن', href: 'https://www.bayut.jo', flag: 'iconJordan' },
  { title: 'Oman', title_l1: 'عُمان', href: 'https://www.bayut.om', flag: 'iconOman' },
  { title: 'Egypt', title_l1: 'مَصر', href: 'https://www.bayut.eg', flag: 'iconEgypt' },
  { title: 'Kuwait', title_l1: 'الكويت', href: 'https://www.bayut.com.kw', flag: 'iconKuwait' },
  { title: 'Qatar', title_l1: 'قطر', href: 'https://www.bayut.qa', flag: 'iconQatar' },
  { title: 'Bahrain', title_l1: 'البحرين', href: 'https://www.bayut.bh', flag: 'iconBahrain' },
];

const flagImage = (flag) => `url(${getBaseURL()}/profolio-assets/${TENANT_KEY}/lite/${flag}.svg)`;

export const FooterCountryDropdown = () => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const closeOnOutsideClick = (event) => {
      if (!containerRef.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', closeOnOutsideClick);
    return () => document.removeEventListener('mousedown', closeOnOutsideClick);
  }, [open]);

  return (
    <div className="country-dropdown" ref={containerRef}>
      <button
        type="button"
        className="country-dropdown-trigger"
        aria-label="Select country"
        aria-expanded={open}
        onClick={() => setOpen((isOpen) => !isOpen)}
      >
        <span className="country-flag" style={{ backgroundImage: flagImage('iconSaudiArabia') }} />
        <span>{tenantUtils.getLocalisedString({ title: 'Saudi Arabia', title_l1: 'السعودية' }, 'title')}</span>
        <Icon icon="IoMdArrowDropdown" size={20} className={cx('dropdownIcon', open && 'open')} />
      </button>
      {open && (
        <ul className="country-dropdown-menu">
          {COUNTRY_SITES.map((site) => (
            <li key={site.href}>
              <a href={site.href}>
                <span className="country-dropdown-flag" style={{ backgroundImage: flagImage(site.flag) }} />
                <span className="country-dropdown-name">{tenantUtils.getLocalisedString(site, 'title')}</span>
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
